
import React from 'react';
import { Popover, Icon, message, Menu, Checkbox } from 'antd';
// import { Row, Col, Button, Input, Label, DatePicker, Refer, TreeRefer, Tag2 } from '../basic';
import { findDOMNode } from 'react-dom';
import * as BasicComponents from '../basic';
import FilterScheme from './FilterScheme';
import addEventListener from 'rc-util/lib/Dom/addEventListener';
import _ from 'lodash'
import env from '../../helpers/env';

// 过滤控件
const Row = BasicComponents.Row,
  Col = BasicComponents.Col,
  Button = BasicComponents.Button,
  Label = BasicComponents.Label,
  Tag2 = BasicComponents.Tag2;
let Sortable = null;
if (process.env.__CLIENT__) Sortable = require('react-sortablejs');
const BasicComponentsMap = {};
for (var attr in BasicComponents)
  BasicComponentsMap[attr.toLocaleLowerCase()] = BasicComponents[attr];
BasicComponentsMap['datepicker'] = BasicComponents['DatePicker_Full']
export default class ConvenientQuery extends React.Component {
  constructor(props) {
    super(props);
    const configFilterId = props.config && props.config.filterid;
    const bHideFilterScheme = props.config && props.config.bHideFilterScheme;
    var params = props.model.getParams();
    if (configFilterId)
      params.multipleFilters = true;
    const filterId = configFilterId || params.filterId;
    const autoExpand = props.config && props.config.autoexpand || props.autoExpand;
    const cardKey = params.cardKey || params.billNo;
    const Id = configFilterId ? filterId : props.model.id
    let cStyle = (props.cStyle && JSON.parse(props.cStyle)) || {};
    this.bHideFilterScheme = cStyle.bHideFilterScheme || bHideFilterScheme || cb.isInTouchReport(props.model) || false;    
    console.log(filterId)
    this.authCodes = cb.rest.AppContext.user && cb.rest.AppContext.user.authCodes || []
    this.userType = cb.rest.AppContext.user && cb.rest.AppContext.user.userType
    this.state = {
      filterId: filterId,
      autoExpand,
      allAutoFlt: true,
      cardKey: cardKey,
      modelId: Id,
      schemeData: [],
      current: '',
      schemeName: '',
      showMore: false,
      popFlag: false,
      filterModel: [],
      tag2FilterCount: 0,
      commonFilterCount: 0,
      filterAreaCount: 0,
      itemStates: {},
      tag2InFirstRow: false
    };
    this.showFields = new Array();
    this.filterModel_Tmp = [];

    this.state.isInPanel = params.isInPanel ? params.isInPanel : false;
    this.state.isInDesign = params.isInDesign ? params.isInDesign : false;
    this.state.panelType = params.panelType || 0;
    // debugger;
    var cacheName = 'FilterViewModel';
    if (configFilterId)
      cacheName += configFilterId;
    this.vm = this.props.model.getCache(cacheName) || cb.loader.initMetaCommonViewModel(
      'FilterViewModel',
      'filterViewModel',
      {
        suffix: configFilterId,
        filterId: filterId,
        condition: params.condition,
        cardKey: cardKey,
        isInPanel: this.state.isInPanel,
        isInDesign: this.state.isInDesign,
        solutionId: params.solutionId,
        viewid: _.get(props.model.getParams(), 'query.viewid'),
        isWaittingTask: _.get(props.model.getParams(), 'isWaittingTask') || false,
        bHasNullDate: props.model.getParams().bHasNullDate || false
      },
      this.props.model,
      ['filterClick']
    );
    this._DocumentMouseDown = this._DocumentMouseDown.bind(this);
    this._TouchStart = this._TouchStart.bind(this);
    this.props.model.on('updateCondition', condition => {
      if (!condition || !condition.commonVOs || !condition.commonVOs.length) return;
      let flag = true;
      this.vm.setCache('condition', condition);
      condition.commonVOs.forEach(a => {
        var attr = a.itemName;
        const itemModel = this.vm.get(attr);
        if (!itemModel) return;
        itemModel.getFromModel().setValue(a.value1);
        const ctrlType = itemModel.getState('ctrlType');
        if (ctrlType && ctrlType.trim().toLocaleLowerCase() === 'tagbutton')
          flag = false;
      });
      if (flag)
        this.SearchEvent();
    });


    this.props.model.on('eChartPanel_GetCondition', () => {
      this.SearchEvent();
    });
  }

  componentDidMount() {
    if (this.vm) {
      this.vm.addListener(this);
      this.vm.on('updateViewMeta', args => {
        if (args.visible != null) {
          const { itemStates } = this.state;
          itemStates[args.code] = { visible: args.visible };
          this.setState({ itemStates });
        } else {
          const model = this.vm.get(args.code);
          if (!model) return;
          const { filterModel } = this.state;
          const item = filterModel.find(a => a.itemName === args.code);
          if (!item) return;
          for (let attr in args) {
            if (attr === 'code') continue;
            model._set_data(attr, args[attr]);
            item[attr] = args[attr];
          }
          this.setState({ filterModel });
        }
      });
      this.vm.on('enterReset', () => {
        this.isEnterMode = true;
      });
      /*add by jinzh1 table中过滤丢失问题*/
      const cacheInitFiltersData = this.vm.getCache('cacheInitFiltersData');
      if (cacheInitFiltersData) this.initFilterFields(cacheInitFiltersData);
    }
    this.mousedownHandler = addEventListener(document, 'mousedown', this._DocumentMouseDown);
    if (cb.isInTouchReport(this.props.model)) {
      this.touchStartHandler = addEventListener(document, "touchstart", this._TouchStart)
    }
  }


  componentDidUpdate() {
    this.props.model.execute('filterHeightUpdate', this.vm.getParams().filterName);
  }

  componentWillUnmount() {
    this.vm.removeListener(this);
    this.mousedownHandler.remove();
    this.mousedownHandler = null;
    if (cb.isInTouchReport(this.props.model)) {
      this.touchStartHandler.remove();
      this.touchStartHandler = null;
    }
  }

  _TouchStart(e) {
    if (e && e.target && e.target.className == "filterMask_TouchRptCls") {
      this.setState({
        showMore: false
      });
    }
  }

  _DocumentMouseDown(e) {
    if (cb.isInTouchReport(this.props.model)) {
      if (e && e.target && e.target.className == "filterMask_TouchRptCls") {
        this.setState({
          showMore: false
        });
      }
    }
    else {
      let p1 = cb.dom(event.target).parents('.filterSetting');
      let p2 = cb.dom(event.target).parents('.ant-popover');
      if (p1.length == 0 && p2.length == 0 && this.state.popFlag) {
        this.setState({
          popFlag: false
        });
      }
    }
  }
  Tag2Clicked = () => {
    this.SearchEvent();
  }

  initFilterFields =(args)=> {
    let self = this;
    let filterModel = [];
    let CommonModel = args.filterDetail.CommonModel;
    let AllFilterModel = args.filterDetail.AllFilterModel;
    let allAutoFlt = true;
    AllFilterModel.forEach(function (eleAll) {
      CommonModel.forEach(function (eleCommon) {

        if (eleAll.id && eleCommon.itemId && eleCommon.itemId == eleAll.id) {
          let tmp = {};
          // tmp.itemName = eleCommon.itemName;
          // tmp.orderId = eleCommon.orderId;
          // tmp.isCommon = eleCommon.isCommon;
          // tmp.multSelect = eleCommon.multSelect;
          // tmp.cShowCaption = eleCommon.cShowCaption;
          // tmp.ctrlType = eleCommon.ctrlType;
          // tmp.value1 = eleCommon.value1 ? eleCommon.value1 : '';
          // tmp.value2 = eleCommon.value2 ? eleCommon.value2 : '';
          // tmp.autoFlt = eleAll.autoFlt;
          // tmp.enumString = eleAll.enumString;
          // tmp.compareLogic = eleAll.compareLogic;
          // tmp.bShowUpDown = false;
          Object.assign(tmp, eleAll, eleCommon);
          filterModel.push(tmp);
          if (!tmp.bAutoflt)
            allAutoFlt = false;
        }
      }, this);
    }, this);
    this.vm.fireEvent('initFilterViewModel', { filterModel: filterModel });
    this.setState({
      schemeData: args.schemeData,
      current: args.current,
      schemeName: args.schemeName,
      filterModel: filterModel.sort(function (a, b) { return a.orderId - b.orderId }),
      allAutoFlt
    });
  }

  SaveSchemeEvent(e) {
    this.state.popFlag = false;
    // this.state.filterModel = this.filterModel_Tmp;
    if (this.vm) {
      let args = {};
      let dataAll = this.vm.collectData(true)
      this.filterModel_Tmp.forEach((ele)=>{
        let DataValue = dataAll[ele.itemName]
        if(DataValue){
          if ((DataValue.value1 instanceof Array) || (DataValue.value2 instanceof Array)) {
            (DataValue.value1 = DataValue.value1.join(",")) || (DataValue.value2 = DataValue.value2.join(","))
          }
          Object.assign(ele,DataValue)
        }
      })
      args.schemeId = this.state.current;
      args.filterModel = this.filterModel_Tmp;
      args.filterId = this.vm.getParams().filterId;
      args.isDefault = 0;
      args.isPublic = 0;
      args.solutionName = this.state.schemeName;
      this.vm.get('save').fireEvent('click', args);
    }
  }
  SearchEvent() {
    if (this.vm) {
      this.vm.fireEvent('searchEvent', { model: this.props.model, solutionid: this.state.current });
      this.vm.get('search').fireEvent('click', { model: this.props.model, solutionid: this.state.current });
    }
  }
  buttonClick(e, type) {
    if (type == 'search') {
      this.SearchEvent();
    }
    else if (type === 'reset') {
      this.vm.get('reset').execute('click');
    }
    else {//
      let showMore = false;
      if (type == 'more') showMore = true;
      this.setState({
        showMore: showMore
      });
      const propertys = this.vm.get('propertyNames') || [];
      const commonModelObj = this.vm.getCache('commonModelObj') || {}
      const excludes = propertys.filter(item => (!commonModelObj[item] || (commonModelObj[item] && commonModelObj[item].isCommon == 0)));
      setTimeout(()=>{
        if (this.vm.validate(null, ['position', 'region', ...excludes])) { // 查询区不校验位置和区域，等位置和区域从公共扩展脚本挪出来后，再修改
          return this.vm.execute('filterSearch');
        }
      },0)
    }
  }
  showPopClick() {

    this.filterModel_Tmp = _.cloneDeep(this.state.filterModel);
    this.setState({
      popFlag: !this.state.popFlag
    });
  }
  onMouseEnter(e, index) {

    this.filterModel_Tmp[index].bShowUpDown = true;
    this.setState({
      popFlag: this.state.popFlag
    });
  }
  onMouseLeave(e, index) {
    this.filterModel_Tmp.forEach(function (ele) {
      ele.bShowUpDown = false;
    });
    this.setState({
      popFlag: this.state.popFlag
    });
  }


  onChecked(e, element, index) {
    let checked = e.target.checked;
    let num = 0;
    if (checked == false) {
      this.filterModel_Tmp.forEach(function (element, index) {
        if (element.isCommon == true) {
          num = num + 1;
        }
      });
      if (num > 1) {
        this.filterModel_Tmp[index].isCommon = checked;
        this.setState({
          popFlag: this.state.popFlag
        });
      }
    }
    else {
      this.filterModel_Tmp[index].isCommon = checked;
      this.setState({
        popFlag: this.state.popFlag
      });
    }
  }

  sortClick(type, index) {
    let maxLen = this.filterModel_Tmp.length - 1;
    let pre = cb.utils.extend(true, {}, this.filterModel_Tmp[index - 1]);
    let next = cb.utils.extend(true, {}, this.filterModel_Tmp[index + 1]);
    let now = cb.utils.extend(true, {}, this.filterModel_Tmp[index]);
    if (type == 'up') {
      if (index != 0) {
        let orderId = pre.orderId;
        pre.orderId = now.orderId;
        now.orderId = orderId;
        this.filterModel_Tmp[index] = pre;
        this.filterModel_Tmp[index - 1] = now;
      }
    } else {
      if (index < maxLen) {
        let orderId = next.orderId;
        next.orderId = now.orderId;
        now.orderId = orderId;
        this.filterModel_Tmp[index] = next;
        this.filterModel_Tmp[index + 1] = now;
      }
    }
    this.setState();
  }
  cancelClick(type) {
    this.setState({
      popFlag: false
    })
  }

  getFilterContent() {
    let filterContent = [];
    this.filterModel_Tmp.forEach(function (element, index) {
      let item;
      // let bShowUpDown = element.bShowUpDown ? element.bShowUpDown : false;
      let isCommon = element.isCommon;
      item = (
        // bShowUpDown ?
        // <Row style={{ minHeight: "25px" }} onMouseEnter={(e) => this.onMouseEnter(e, index)} onMouseLeave={(e) => this.onMouseLeave(e, index)}>
        //   <div className='pull-left' title={element.cShowCaption}>
        //     <Checkbox checked={isCommon} onChange={(e) => this.onChecked(e, element, index)}>{element.cShowCaption}</Checkbox>
        //   </div>
        //   <div className='pull-right'>
        //     <Button style={{ borderWidth: 0 }} icon="arrow-up" onClick={() => this.sortClick('up', index)}></Button>
        //     <Button style={{ borderWidth: 0 }} icon="arrow-down" onClick={() => this.sortClick('down', index)}></Button>
        //   </div>
        // </Row>
        // :
        <Row style={{ minHeight: "25px" }} key={_.uniqueId()} data-id={element.id}>
          <Icon type="tuodong" />
          <div className='pull-left' title={element.cShowCaption}>
            <Checkbox checked={isCommon} onChange={(e) => this.onChecked(e, element, index)}>{element.cShowCaption}</Checkbox>
          </div>
          {/* <div className='pull-right'></div> */}
        </Row>
      )
      filterContent.push(item);
    }, this);
    let buttonClass = 'filter-btn-fixed';
    return (
      <div className={buttonClass} style={{ overflow: "auto", height: "286px" }}>
        <div className='filter-txt'>
          <Sortable
            tag='div'
            options={{
              group: {
                name: 'shared',
                pull: false,
                put: false
              },
              animation: 150,
              ghostClass: 'blue-background-class',
              scroll: true,
              scrollSensitivity: 10,
              scrollSpeed: 30,
            }}
            onChange={(order) => {
              this.dragOrder(order)
            }}

          >
            {filterContent}
          </Sortable>

        </div>
        <div className='filter-btn-1'>
          <Button type={"primary"} onClick={() => this.SaveSchemeEvent('save')}>保存</Button>
          <Button type={"default"} onClick={() => this.cancelClick('cancel')}>取消</Button>
        </div>
      </div>
    );
  }
  dragOrder(order) {
    let copyList = [];
    order.forEach((evl) => {
      this.filterModel_Tmp.forEach((ele) => {
        if (evl == ele.id) {
          copyList.push(ele)
        }
      })
    })
    this.filterModel_Tmp = copyList;
    this.setState()
  }
  checkTagAndFilterInfo() {
    this.state.tag2FilterCount = 0;
    this.state.commonFilterCount = 0;
    this.state.filterModel.forEach(function (ele, index) {
      if (ele.isCommon == 1 || ele.isCommon == true) {
        if (ele.ctrlType.toLocaleLowerCase() == "tagbutton" && ele.autoFlt == true) {
          this.state.tag2FilterCount = this.state.tag2FilterCount + 1;
        }
        else {
          this.state.commonFilterCount = this.state.commonFilterCount + 1;
        }
      }
    }, this
    )
  }

  handleSchemeChange = (solutionId) => {
    this.vm.fireEvent('loadScheme', solutionId);
  }
  handleSchemeListChange = (solutionList) => {
    this.vm.setCache('schemeList', solutionList);
  }

  onKeyDown = (e) => {
    if (e.keyCode !== 13) return;
    if (e && e.target && cb.dom(findDOMNode(e.target)).parents('.refer-div').length) return;
    if (this.isEnterMode) {
      this.isEnterMode = false;
      return;
    }
    this.SearchEvent();
  }

  render() {
    this.checkTagAndFilterInfo();
    let tag2FilterCount = this.state.tag2FilterCount;
    let commonFilterCount = this.state.commonFilterCount;
    let tags;
    let controls = [];
    let content = null;
    let showMore = this.state.showMore;

    if (commonFilterCount > 0 || tag2FilterCount > 0) {
      let tmpShowMoreStr = (showMore ?
        (<Button style={{ borderWidth: 0 }} className="showMore" type="ghost" size="small" onClick={(e) => this.buttonClick(e, '')}><Icon type="up-circle" /></Button>)
        :
        (<Button style={{ borderWidth: 0 }} className="showMore" type="ghost" size="small" onClick={(e) => this.buttonClick(e, 'more')}><Icon type="down-circle" /></Button>)
      );
      controls = this.getControls(tmpShowMoreStr);
    }
    if (this.filterModel_Tmp && this.filterModel_Tmp.length > 0) {
      content = this.getFilterContent();
    }
    let filterAreaCount = this.state.filterAreaCount;
    let showMoreStr;
    let rowNum = this.props.cols ? this.props.cols : 3;

    if (filterAreaCount > rowNum && !this.state.autoExpand) {//&& this.state.isInPanel == false
      showMoreStr = (showMore ?
        (<Button style={{ borderWidth: 0 }} className="showMore" type="ghost" size="small" onClick={(e) => this.buttonClick(e, '')}><Icon type="up-circle" /></Button>)
        :
        (<Button style={{ borderWidth: 0 }} className="showMore" type="ghost" size="small" onClick={(e) => this.buttonClick(e, 'more')}><Icon type="down-circle" /></Button>)
      );
    }
    else {
      showMoreStr = (<span style={{ paddingLeft: 5 }}></span>);
    }
    // if (this.state.panelType == 3) {
    //   controls.push(showMoreStr);
    // }
    let showSearchStr;
    if (this.state.tag2InFirstRow == false || (commonFilterCount > 0 && showMore) || this.state.autoExpand || this.props.filterDisplayType !== "waittingTask") {
      if (this.state.isInDesign == false && !this.state.allAutoFlt) {
        showSearchStr = (<Button delay type="ghost" style={{ float: "right" }} className="up-search" onClick={(e) => this.buttonClick(e, 'search')}>搜索</Button>);
      }
    }
    else {
      showSearchStr = (<span style={{ paddingLeft: 5 }}></span>);
    }
    let showResetBtn;
    if (cb.isInTouchReport(this.props.model)) {
      showResetBtn = (<Button type="default" onClick={(e) => this.buttonClick(e, 'reset')}>重置</Button>);
    }
    let showFilterSetting;
    let { panelType } = this.props;
    if (
      // this.state.filterModel.length > rowNum
      // && !this.state.autoExpand
      // && this.state.isInPanel == false
      // && (this.state.isInDesign == false || (this.state.isInDesign == true && panelType == 2))
      this.state.filterModel.length > rowNum
      && !this.state.autoExpand
      && (this.state.isInPanel == false ||
        (this.state.isInPanel == true && this.state.isInDesign == true && panelType == 2))
      && cb.isInTouchReport(this.props.model) === false
      && this.props.filterDisplayType !== "waittingTask"
    ) {
      if ((this.authCodes.indexOf("userdef_schemaSetting") > -1 || this.userType == 0))
        showFilterSetting = (
          <Popover overlayClassName="sort_popover" overlayStyle={{ width: "200px" }} placement={"bottomRight"} content={content} trigger={"click"} visible={this.state.popFlag}>
            <div className="ant-popover-open-count">
              <Button className="filterSetting" style={{ borderWidth: 1 }} onClick={() => this.showPopClick()} type={"ghost"} size="small" >设置</Button>

            </div>
          </Popover>);
      else
        showFilterSetting = (<span style={{ paddingLeft: 5 }}></span>);
    }
    else {
      showFilterSetting = (<span style={{ paddingLeft: 5 }}></span>);
    }
    let clsName = `${this.props.config && this.props.config.classname} ${this.state.autoExpand === false && 'voucher-filter'}`;
    let touchRptMask;
    let innerArr = [];
    innerArr.push(
      <Col className='filter-controls'>
        <div onKeyDown={this.onKeyDown}>
          <Row colCount={rowNum}>
            {controls}
          </Row>
        </div>
      </Col>);
    innerArr.push(
      <Col className="up-show" >
        {this.state.panelType == 3 ? "" : showMoreStr}
        {showFilterSetting}
        {showSearchStr}
        {showResetBtn}
      </Col>);
    if (cb.isInTouchReport(this.props.model)) {
      clsName = clsName + " CommonFilter_TouchRptCls ";
      let innerClsName = "filterInner_Close_TouchRptCls"
      if (this.state.showMore || this.state.autoExpand) {
        touchRptMask = <div className="filterMask_TouchRptCls"  ></div>;
        innerClsName = "filterInner_Close_TouchRptCls filterInner_Open_TouchRptCls";
      }
      innerArr = <div className={innerClsName}>{innerArr}</div>;
    }
    return (
      <Row className={clsName}>
        {env.INTERACTIVE_MODE !== 'touch' && this.bHideFilterScheme == false && <FilterScheme filterId={this.state.filterId} Id={this.state.modelId} cardKey={this.state.cardKey} schemeChange={this.handleSchemeChange} schemeListChange={this.handleSchemeListChange} model={this.props.model} />}
        {innerArr}
        {touchRptMask}
      </Row >
    );
  }
  // handleSolutionChange=(solutionId)=>{
  //   this.vm.fireEvent();
  // solutionChange={this.handleSolutionChange}
  // }
  getControls(tmpShowMoreStr) {
    let controls = [];
    let control, filterVMField;
    let tmp_FilterAreaCount = 0
    let cur_FilterAreaCount = 0
    let cur_Tag2InFirstRow = false;
    let rowNum = this.props.cols ? this.props.cols : 3;
    const { itemStates } = this.state;
    this.state.filterModel.forEach(function (ele, index) {
      if (itemStates[ele.itemName] && itemStates[ele.itemName].visible === false) return;
      const ctrlType = ele.ctrlType.trim().toLocaleLowerCase();
      if (ele.isCommon == 1 || ele.isCommon == true) {
        control = undefined;
        let config = null;
        try {
          config = JSON.parse(ele.extendField);
        } catch (e) {
          config = {};
        }
        // delete ele.extendField;
        if (ctrlType === 'tagbutton') {
          if (ele.autoFlt == true) {
            cur_FilterAreaCount = config.cols || rowNum;
            tmp_FilterAreaCount = tmp_FilterAreaCount + cur_FilterAreaCount;
            if (tmp_FilterAreaCount === rowNum) { cur_Tag2InFirstRow = true; }
            // let filterVMField;
            // if (!this.vm.get(ele.itemName)) {
            //   let initData = cb.utils.extend(true, {}, ele);
            //   initData.value1 = ele.value1;
            //   filterVMField = new cb.models.FilterModel(initData);
            //   this.vm.addProperty(initData.itemName, filterVMField);
            // }
            // else {
            filterVMField = this.vm.get(ele.itemName);
            // }
            let fromModel = filterVMField.getFromModel();
            control = (
              <Row key={ele.itemName}>
                <Col  >
                  <Tag2
                    TagTitle={ele.cShowCaption}
                    TagData={ele.enumString}
                    TagCanMultSel={ele.multSelect == 0 ? false : true}
                    TagClicked={this.Tag2Clicked}
                    model={fromModel}              >
                  </Tag2>
                </Col>
              </Row>
            );
          }
        }
        else if (ctrlType === 'predicatedatepicker') {
          cur_FilterAreaCount = rowNum;
          tmp_FilterAreaCount += cur_FilterAreaCount;
          const ComName = BasicComponentsMap[ctrlType];
          const model = this.vm.get(ele.itemName).getFromModel();
          control = (
            <Row key={ele.itemName} >
              <ComName
                model={model}
                isInPanel={this.state.isInPanel}
                isInDesign={this.state.isInDesign}
                panelType={this.state.panelType}
                cShowCaption={ele.cShowCaption}
                isInFilterJSX={true}
              />
            </Row>
          );
        }
        else {
          cur_FilterAreaCount = config.cols || 1;
          tmp_FilterAreaCount = tmp_FilterAreaCount + cur_FilterAreaCount;
          // if (!this.vm.get(ele.itemName)) {
          //   let initData = cb.utils.extend(true, {}, ele);
          //   initData.value1 = ele.value1;
          //   initData.value2 = ele.value2;
          //   filterVMField = new cb.models.FilterModel(initData);
          //   this.vm.addProperty(initData.itemName, filterVMField);
          // }
          // else {
          filterVMField = this.vm.get(ele.itemName);
          // }
          if (!!filterVMField)
            control = this.getControl(ele, filterVMField, config);


        }
        if (control) {

          let tmpClassName = "";
          let tmp;
          if (this.state.panelType == 3 && controls.length == 0) {
            tmpClassName = "UpDown_Location";
            tmp = tmpShowMoreStr;
          }

          if (this.state.showMore || this.state.autoExpand || cb.isInTouchReport(this.props.model)) {
            controls.push(<Col  id={`${this.state.cardKey}|${ele.itemName}`}  key={ele.itemName} span={cur_FilterAreaCount} className={tmpClassName} >{control}{tmp}</Col>);
          }
          else {
            if (tmp_FilterAreaCount <= rowNum) {
              controls.push(<Col key={ele.itemName}  id={`${this.state.cardKey}|${ele.itemName}`}  span={cur_FilterAreaCount} className={tmpClassName}  >{control}{tmp}</Col>);
            }
          }
        }
      }
    }, this);
    this.state.filterAreaCount = tmp_FilterAreaCount;
    this.state.tag2InFirstRow = cur_Tag2InFirstRow;
    return controls;
    // return (<div  ><Row colCount={rowNum}>{controls}</Row></div>);
    // return (<div  ><Row colCount={tmp_FilterAreaCount < 3 ? 3 : 3}>{controls}</Row></div>);
    // return (<div  ><Row colCount={tmp_FilterAreaCount < 3 ? tmp_FilterAreaCount : 3}>{controls}</Row></div>);
  }
  getComponent(ComName, model, config, ctrlType, cShowCaption) {
    return ComName ? <ComName model={model} title={cShowCaption} isInFilterJSX={true} {...config} /> : <h1>{ctrlType}</h1>;
  }
  getControl(ele, filterVMField, config) {
    let compareLogic = ele.compareLogic;
    let fromModel = filterVMField.getFromDisplayModel() || filterVMField.getFromModel();
    let toModel = filterVMField.getToModel();
    let ctrlType;
    // if(ele.ctrlType == "DatePicker"){
    //   fromModel && fromModel.setValue(ele.value1)
    //   toModel && toModel.setValue(ele.value2)
    // }
    if (ele.ctrlType)
      ctrlType = ele.ctrlType.trim().toLocaleLowerCase();
    else
      ctrlType = "input";
    const ComName = BasicComponentsMap[ctrlType];
    let control;
    if (compareLogic === 'between') {
      control = (
        <div className="Test-time-two">
          <Col span={11}>{this.getComponent(ComName, fromModel, config, ctrlType)}</Col>
          <Col span={2} className="sp-range-txt"><span>至</span></Col>
          <Col span={11}>{this.getComponent(ComName, toModel, config, ctrlType)}</Col>
        </div>
      );
    }
    else {
      control = this.getComponent(ComName, fromModel, config, ctrlType, ele.cShowCaption);
    }
    return (<div className='filter-hide'><Label isInFilterJSX={true} control={control} title={ele.cShowCaption} /></div>);
  }
};




// WEBPACK FOOTER //
// ./src/yxyweb/common/components/filter/index.jsx